<div class="grayHeader block editorDisplayBanner">
  <table style="width:100%;">
    <tr class="grayHeaderRowHead">
      <td>Rebalance Name</td>
      <td>Rebalance Type</td>
      <td>Rebalance ID #</td>
      <td>Portfolio Name</td>
      <td>Outcome</td>
      <td rowspan="2" style="vertical-align: middle;">
        <button class="btn-medium-secondary" [disabled]="!hasExplanation" data-view-explanations
                (click)="showExplanation()">View Explanations
        </button>
      </td>
    </tr>
    <tr>
      <td data-rebalance-name><a href="javascript:void(0)" (click)="viewRebalance()">{{data.rebalanceName}}</a></td>
      <td data-rebal-type>{{data.rebalType}}</td>
      <td data-rebal-id>{{data.rebalId}}</td>
      <td data-portfolio-name>{{data.portfolioName}}</td>
      <td data-original-outcome>{{data.originalOutcome}}</td>
    </tr>
  </table>
</div>
